var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Watch, P, PCSS, CustomElement, ViewChild, Utils, PropertyConverters, Defaults, DeferPromise } from '@pacem/pacem-core';
import { PacemFormRelevantElement } from './form';
// TODO: add warning state
export class PacemBaseValidatorElement extends PacemFormRelevantElement {
    constructor() {
        super();
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        Utils.addClass(this, PCSS + '-validator');
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        let form = this.form;
        switch (name) {
            case 'watch':
                old && form && form.unregisterValidator(val, this);
                form && form.registerValidator(val, this);
                break;
            case 'invalid':
                break;
            case 'form':
                let n = this.watch;
                if (!Utils.isNullOrEmpty(n)) {
                    if (old != null)
                        old.unregisterValidator(n, this);
                    if (val != null)
                        val.registerValidator(n, this);
                }
                break;
            case 'disabled':
                this.triggerFormFieldValidation();
                break;
        }
    }
    #easer;
    triggerFormFieldValidation() {
        const form = this.form, watch = this.watch;
        if (!Utils.isNull(form) && !Utils.isNullOrEmpty(watch)) {
            cancelAnimationFrame(this.#easer);
            this.#easer = requestAnimationFrame(() => {
                form.validate(watch);
            });
        }
    }
    validate(val) {
        if (this.disabled) {
            return Utils.fromResult(true);
        }
        return this.evaluate(val);
    }
}
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemBaseValidatorElement.prototype, "invalid", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemBaseValidatorElement.prototype, "errorMessage", void 0);
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.String })
], PacemBaseValidatorElement.prototype, "watch", void 0);
export const BASIC_VALIDATOR_TEMPLATE = `<${P}-span part="error-message" hide="{{ !:host.invalid  }}" text="{{ :host.errorMessage }}"></${P}-span>`;
// #region TEXTUAL
function isValueEmpty(val) {
    return Utils.isNullOrEmpty(val);
}
let PacemRequiredValidatorElement = class PacemRequiredValidatorElement extends PacemBaseValidatorElement {
    evaluate(val) {
        let retval = !isValueEmpty(val);
        return Utils.fromResult(retval);
    }
};
PacemRequiredValidatorElement = __decorate([
    CustomElement({ tagName: P + '-required-validator', template: BASIC_VALIDATOR_TEMPLATE, shadow: Defaults.USE_SHADOW_ROOT })
], PacemRequiredValidatorElement);
export { PacemRequiredValidatorElement };
let PacemRegexValidatorElement = class PacemRegexValidatorElement extends PacemBaseValidatorElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first && name === 'pattern') {
            this.triggerFormFieldValidation();
        }
    }
    evaluate(val) {
        let retval = true, pattern = this.pattern;
        if (!isValueEmpty(val)) {
            retval = new RegExp(pattern).test(val);
        }
        return Utils.fromResult(retval);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemRegexValidatorElement.prototype, "pattern", void 0);
PacemRegexValidatorElement = __decorate([
    CustomElement({ tagName: P + '-regex-validator', template: BASIC_VALIDATOR_TEMPLATE, shadow: Defaults.USE_SHADOW_ROOT })
], PacemRegexValidatorElement);
export { PacemRegexValidatorElement };
let PacemLengthValidatorElement = class PacemLengthValidatorElement extends PacemBaseValidatorElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first &&
            (name === 'min' || name === 'max')) {
            this.triggerFormFieldValidation();
        }
    }
    evaluate(val) {
        let retval = true;
        if (!isValueEmpty(val)) {
            if (this.min >= 0)
                retval = retval && (val || '').toString().length >= this.min;
            if (this.max >= 0)
                retval = retval && (val || '').toString().length <= this.max;
        }
        return Utils.fromResult(retval);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemLengthValidatorElement.prototype, "min", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemLengthValidatorElement.prototype, "max", void 0);
PacemLengthValidatorElement = __decorate([
    CustomElement({ tagName: P + '-length-validator', template: BASIC_VALIDATOR_TEMPLATE, shadow: Defaults.USE_SHADOW_ROOT })
], PacemLengthValidatorElement);
export { PacemLengthValidatorElement };
// #endregion
// #region NUMERIC/ORDINAL
let PacemRangeValidatorElement = class PacemRangeValidatorElement extends PacemBaseValidatorElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first &&
            (name === 'min' || name === 'max')) {
            this.triggerFormFieldValidation();
        }
    }
    evaluate(val) {
        let retval = true;
        if (!isValueEmpty(val)) {
            let date = val;
            if (val instanceof Date || (typeof val !== 'number' && (date = Utils.parseDate(val)) instanceof Date && isFinite(date.valueOf()))) {
                if (this.min != null)
                    retval = retval && date.valueOf() >= Utils.parseDate(this.min).valueOf();
                if (this.max != null)
                    retval = retval && date.valueOf() <= Utils.parseDate(this.max).valueOf();
            }
            else {
                if (this.min != null)
                    retval = retval && val >= this.min;
                if (this.max != null)
                    retval = retval && val <= this.max;
            }
        }
        return Utils.fromResult(retval);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemRangeValidatorElement.prototype, "min", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemRangeValidatorElement.prototype, "max", void 0);
PacemRangeValidatorElement = __decorate([
    CustomElement({ tagName: P + '-range-validator', template: BASIC_VALIDATOR_TEMPLATE, shadow: Defaults.USE_SHADOW_ROOT })
], PacemRangeValidatorElement);
export { PacemRangeValidatorElement };
// #endregion
// #region COMPLEX
let PacemCompareValidatorElement = class PacemCompareValidatorElement extends PacemBaseValidatorElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first &&
            (name === 'operator' || name === 'to')) {
            this.triggerFormFieldValidation();
        }
    }
    _prepareValuesForComparison(val, other) {
        // gotta manage the case when a stringified datetime is compared with an actual date object.
        if (Utils.Dates.isDate(val) || Utils.Dates.isDate(other)) {
            return [Utils.parseDate(val), Utils.parseDate(other)];
        }
        return [val, other];
    }
    evaluate(val) {
        let retval = true, other = this.to;
        if (!isValueEmpty(val) && !isValueEmpty(other)) {
            const arranged = this._prepareValuesForComparison(val, other);
            val = arranged[0], other = arranged[1];
            switch (this.operator) {
                case 'lessOrEqual':
                    retval = val <= other;
                    break;
                case 'less':
                    retval = val < other;
                    break;
                case 'greaterOrEqual':
                    retval = val >= other;
                    break;
                case 'greater':
                    retval = val > other;
                    break;
                case 'notEqual':
                    retval = val !== other;
                    break;
                default:
                    retval = val === other;
                    break;
            }
        }
        return Utils.fromResult(retval);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemCompareValidatorElement.prototype, "operator", void 0);
__decorate([
    Watch({ emit: false, reflectBack: true })
], PacemCompareValidatorElement.prototype, "to", void 0);
PacemCompareValidatorElement = __decorate([
    CustomElement({ tagName: P + '-compare-validator', template: BASIC_VALIDATOR_TEMPLATE, shadow: Defaults.USE_SHADOW_ROOT })
], PacemCompareValidatorElement);
export { PacemCompareValidatorElement };
// #endregion
let PacemBinaryValidatorElement = class PacemBinaryValidatorElement extends PacemBaseValidatorElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first &&
            (name === 'pattern' || name === 'maxSize')) {
            this.triggerFormFieldValidation();
        }
    }
    evaluate(val) {
        let retval = true, pattern = this.pattern, maxSize = this.maxSize;
        if (!isValueEmpty(val)) {
            // file name
            if (!Utils.isNullOrEmpty(pattern)) {
                let filename = typeof val === 'string' ? val : val.name;
                retval = new RegExp(pattern, 'i').test(filename);
            }
            // max size
            if (!Utils.isNull(maxSize) && typeof val === 'object' && val.size > 0) {
                retval = retval && val.size <= maxSize;
            }
        }
        return Utils.fromResult(retval);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemBinaryValidatorElement.prototype, "pattern", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemBinaryValidatorElement.prototype, "maxSize", void 0);
PacemBinaryValidatorElement = __decorate([
    CustomElement({ tagName: P + '-binary-validator', template: BASIC_VALIDATOR_TEMPLATE, shadow: Defaults.USE_SHADOW_ROOT })
], PacemBinaryValidatorElement);
export { PacemBinaryValidatorElement };
let PacemAsyncValidatorElement = class PacemAsyncValidatorElement extends PacemBaseValidatorElement {
    constructor() {
        super(...arguments);
        this._deferredToken = null;
    }
    _evaluateResult() {
        const fetcher = this._fetcher;
        const result = fetcher.result;
        switch (result) {
            case 'true':
                return true;
                break;
            case 'false':
                return false;
                break;
            default: // expect json
                try {
                    let json = JSON.parse(result);
                    let res = Utils.getApiResult(json);
                    return (res || false);
                }
                catch (_) {
                    return false;
                }
        }
    }
    _fetch(val) {
        const deferred = this._deferredToken;
        const fetcher = this._fetcher;
        var params = this.parameters || {};
        params[this.watch] = val;
        const request = {
            parameters: params,
            url: this.url,
            as: 'text',
            method: this.method
        };
        const serializedRequest = Utils.jsonSortStringify(request);
        // check changed:
        // assume idempotent with last request.
        const lastRequest = this.#lastRequest;
        let returnLastResult = false;
        if (!Utils.isNullOrEmpty(lastRequest)) {
            returnLastResult = (serializedRequest === lastRequest);
        }
        if (returnLastResult) {
            const result = this._evaluateResult();
            deferred.resolve(result);
        }
        else {
            Utils.extend(fetcher, request);
            // debounce
            clearTimeout(this._debouncer);
            this._debouncer = setTimeout(() => {
                fetcher.fetch().then(_ => {
                    const result = this._evaluateResult();
                    deferred.resolve(result);
                    // memoize last successful request
                    this.#lastRequest = serializedRequest;
                }, _ => {
                    deferred.resolve(false);
                });
            }, 1000);
        }
        return deferred.promise;
    }
    #lastRequest;
    evaluate(val) {
        if (Utils.isNullOrEmpty(val)) {
            return Utils.fromResult(true);
        }
        else {
            this._deferredToken = this._deferredToken = DeferPromise.defer();
            return this._fetch(val).then(r => {
                this._deferredToken = null;
                return r;
            }, _ => {
                this._deferredToken = null;
                return false;
            });
        }
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'parameters':
                case 'url':
                case 'method':
                case 'fetchCredentials':
                case 'fetchHeaders':
                    this.triggerFormFieldValidation();
                    break;
            }
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemAsyncValidatorElement.prototype, "parameters", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemAsyncValidatorElement.prototype, "fetchCredentials", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemAsyncValidatorElement.prototype, "fetchHeaders", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemAsyncValidatorElement.prototype, "url", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemAsyncValidatorElement.prototype, "method", void 0);
__decorate([
    ViewChild(P + '-fetch')
], PacemAsyncValidatorElement.prototype, "_fetcher", void 0);
PacemAsyncValidatorElement = __decorate([
    CustomElement({
        tagName: P + '-async-validator',
        template: BASIC_VALIDATOR_TEMPLATE + `<${P}-fetch autofetch="false" throttle="true" credentials="{{ :host.fetchCredentials }}" headers="{{ :host.fetchHeaders }}"></${P}-fetch>`, shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemAsyncValidatorElement);
export { PacemAsyncValidatorElement };
let PacemCustomValidatorElement = class PacemCustomValidatorElement extends PacemBaseValidatorElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first &&
            (name === 'isValid')) {
            this.triggerFormFieldValidation();
        }
    }
    evaluate(val) {
        let retval = true;
        if (!isValueEmpty(val)) {
            retval = !!this.isValid;
        }
        return Utils.fromResult(retval);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemCustomValidatorElement.prototype, "isValid", void 0);
PacemCustomValidatorElement = __decorate([
    CustomElement({ tagName: P + '-custom-validator', template: BASIC_VALIDATOR_TEMPLATE, shadow: Defaults.USE_SHADOW_ROOT })
], PacemCustomValidatorElement);
export { PacemCustomValidatorElement };
